/*
 * Story Theme
 *
 * Use this file to add custom Javascript to Story.  Keeping your custom
 * Javascript in this fill will make it easier to update Story. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */


$(document).ready(function() {
    // Keep your scripts inside this IIFE function call to avoid leaking your variables into the global scope.
    // Checkout ToC
        $(document).ready(function () {
            $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function () {
                if ($('#agree').is(':checked')) {
                    $(this).submit()
                }
                else {
                    alert("Du skal sætte flueben ved vores handelsbetingelser for, at kunne fortsætte til checkud.")
                    return false
                }
            })
        })
})